import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Unlock } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

export const Differentiator = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(scrollYProgress, [0, 1], ["6%", "-6%"]);

  return (
    <section
      ref={ref}
      data-testid="differentiator-section"
      className="relative overflow-hidden border-y border-white/10 bg-[#04122e] py-24 md:py-36 noise-overlay"
    >
      <div className="absolute inset-0 grid-lines opacity-30" />
      <div className="absolute left-1/2 top-1/2 h-[600px] w-[900px] -translate-x-1/2 -translate-y-1/2 blue-glow opacity-70" />

      {/* Big moving background word */}
      <motion.div
        style={{ x }}
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-6 select-none whitespace-nowrap text-center font-display text-[18vw] font-bold leading-none text-white/[0.03]"
      >
        {t.differentiator.main}
      </motion.div>

      <div className="relative mx-auto max-w-5xl px-5 sm:px-8 text-center">
        <Reveal>
          <div className="mx-auto mb-8 flex h-16 w-16 items-center justify-center rounded-2xl border border-[#00e5ff]/30 bg-[#00e5ff]/10">
            <Unlock className="h-7 w-7 text-[#00e5ff]" />
          </div>
        </Reveal>
        <Reveal delay={0.05}>
          <span className="font-mono-wt text-xs md:text-sm font-bold uppercase tracking-[0.3em] text-[#00e5ff]">
            {t.differentiator.overline}
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-5xl sm:text-6xl lg:text-8xl font-light tracking-tighter text-white">
            {t.differentiator.main}
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mx-auto mt-8 max-w-2xl font-display text-xl md:text-2xl font-light italic text-zinc-200">
            {t.differentiator.quote}
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <p className="mx-auto mt-6 max-w-2xl text-base md:text-lg font-light text-zinc-400">
            {t.differentiator.secondary}
          </p>
        </Reveal>
      </div>
    </section>
  );
};
